import { useRastreo } from './useRastreo'
import estilos from './Rastreo.module.css'

/**
 * El interruptor del rastreo.
 *
 * Va a la vista y se enciende a mano, nunca solo. Un rastreo que arranca sin
 * que la persona lo sepa no se puede sustentar ante nadie, y además la ley
 * pide que el trabajador sepa qué se está capturando de él.
 *
 * Mientras está encendido se ve encendido: el punto que late no es adorno, es
 * la señal de que el teléfono está reportando.
 */
export function Rastreo() {
  const { estado, encender, apagar, geocercas } = useRastreo()

  const enSitio = geocercas.filter((cerca) => cerca.en_sitio).length

  return (
    <div className={`${estilos.zona} ${estado.activo ? estilos.encendido : ''}`}>
      <div className={estilos.izquierda}>
        {estado.activo && <span className={estilos.latido} aria-hidden="true" />}

        <div>
          <p className={estilos.titulo}>
            {estado.activo ? 'Reportando ubicación' : 'Ubicación apagada'}
          </p>

          <p className={estilos.texto}>
            {estado.activo ? (
              <>
                {geocercas.length === 0 ? (
                  'No tiene órdenes con dirección ubicada, así que no hay área que vigilar.'
                ) : (
                  <>
                    Vigilando {geocercas.length}{' '}
                    {geocercas.length === 1 ? 'área de trabajo' : 'áreas de trabajo'}
                    {enSitio > 0 && <> · adentro de {enSitio}</>}. Solo avisa al entrar y al salir,
                    no todo el tiempo.
                  </>
                )}
                {estado.ultimo && (
                  <>
                    {' '}
                    Último punto con ±{Math.round(estado.ultimo.exactitud)} m.
                  </>
                )}
              </>
            ) : (
              'Al encenderla, el teléfono vigila las áreas de sus órdenes y avisa solo cuando entra o sale de una. No reporta dónde está el resto del tiempo.'
            )}
          </p>

          {estado.ultimoEvento && (
            <p className={estilos.evento}>
              {estado.ultimoEvento.evento === 'llegada' ? 'Llegó a' : 'Salió de'}{' '}
              <b>{estado.ultimoEvento.ordenNumero}</b>, a{' '}
              {Math.round(estado.ultimoEvento.distancia)} m.
            </p>
          )}

          {estado.error && <p className={estilos.error}>{estado.error}</p>}
        </div>
      </div>

      <button
        type="button"
        className={estado.activo ? estilos.apagar : estilos.encender}
        onClick={() => (estado.activo ? apagar() : encender())}
      >
        {estado.activo ? 'Apagar' : 'Encender'}
      </button>
    </div>
  )
}
